import { render, staticRenderFns } from "./SalaryPaymentLayout.vue?vue&type=template&id=05d8f4c6&scoped=true"
import script from "./SalaryPaymentLayout.vue?vue&type=script&lang=js"
export * from "./SalaryPaymentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8f4c6",
  null
  
)

export default component.exports